import { useDispatch } from 'react-redux';
import { downloadFile } from '@mews-commander/legacy-entities/src/actions/files';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { OptimusPlainLink } from '@mews-commander/ui';
import { Identifiable } from '@mews/std';

interface FileDownloadLinkProps extends Identifiable {
    name: string;
    isCompanyFile?: boolean;
}

export const FileDownloadLink = ({ name, id, isCompanyFile }: FileDownloadLinkProps) => {
    const dispatch: CommanderThunkDispatch = useDispatch();
    const handleClick = () => {
        dispatch(downloadFile({ id, isCompanyFile }));
    };
    return (
        <OptimusPlainLink onClick={handleClick} wordBreak="break-all" inherit>
            {name}
        </OptimusPlainLink>
    );
};
